import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicCustomForm = React.lazy(() => import(/* webpackChunkName: "dynamic-custom-form" */ './DynamicCustomForm'));

componentService.registerPageComponents({ 'dynamic-custom-form': DynamicCustomForm });
